import {useState, useCallback, useEffect} from 'react';

// Control grid display states
export default function useGridState(initialState, gridRef){

  const [gridState, setGridState] = useState(initialState);
  const [persistentProps, setPersistentProps] = useState({})
  const gridApi = gridRef?.current?.api;

  // When doing state update, the grid might not be ready to handle this. 
  // Hence do it using once a listener
  const ensureColumnVisibleAfterStateUpdate = useCallback((selectedColumn) => {
      const listener = () => {
        gridApi.ensureColumnVisible(selectedColumn, 'middle');
        gridApi.removeEventListener('newColumnsLoaded', listener);
      }
      gridApi.addEventListener('newColumnsLoaded', listener);
  }, [gridApi]);

  const setExcelGrid = () => {
        if (gridApi) {
          // gridApi.setFilterModel([]);
    
          let updatedState = gridApi.getColumnState().map((colState) => {
            // Only show columns from excel & row number
            colState.hide = !(colState.colId.includes('-e') || colState.colId.includes('#'))
            return colState;
          });
          gridApi.applyColumnState({state: updatedState});
        }
        setGridState('excel')
  }

  const setDataGrid = (props = {}) => {
    const {selectedColumn} = props;

    if (gridApi) {
      gridApi.setFilterModel([]); // Reset filters

      let columnDefs = gridApi.getGridOption('columnDefs');
      columnDefs.forEach(colDef => {
        if(colDef.field == selectedColumn) { // Selected column
          colDef.cellStyle = {backgroundColor: 'rgba(71, 169, 166, 0.2)'}
        } else {
          colDef.cellStyle = {} // Reset others
        }
      })
      gridApi.setGridOption('columnDefs', columnDefs);

      // Modify the visibility for the target column
      if (gridState !== 'datagrid') {
        let updatedState = gridApi.getColumnState()
        updatedState.forEach((colState) => {
          colState.hide = false;
          // Only show columns from excel
          if (colState.colId.includes('-e')) colState.hide = true;
        });
        gridApi.applyColumnState({state: updatedState});
        ensureColumnVisibleAfterStateUpdate(selectedColumn)
      }
      gridApi.ensureColumnVisible(selectedColumn, 'middle');
    }
    setGridState('datagrid')
  }

  const toggleGrid = (type, props = null) => {
    let newProps = {...persistentProps, [type]: props ? props : persistentProps[type]};
    setPersistentProps(newProps)
    type == 'excel' ? setExcelGrid(newProps[type]) : type != null && setDataGrid(newProps[type]);
  } 
  return {toggleGrid, gridState}
}